











import Vue from 'vue';
import NeoInput from '@/components/NeoInput.vue';
import SystemMessage from '@/components/SystemMessage.vue';

export default Vue.extend({
  name: 'NeoCommand',
  components: {
    NeoInput,
    SystemMessage
  },
  data() {
    return {
      showError: false
    }
  }
});
